var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatchedWith(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11124_111329",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 17.5V0.5H0.5V17.5H17.5Z",
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11124_111329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.78125 16.4141V17.4688",
    stroke: "#FF9B6B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.89062 15.3594L7.94531 16.4141",
    stroke: "#FF9B6B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.67188 15.3594L1.61719 16.4141",
    stroke: "#FF9B6B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2188 1.57812V0.523437",
    stroke: "#FF9B6B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3281 2.63281L16.3828 1.57812",
    stroke: "#FF9B6B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1094 2.63281L10.0547 1.57812",
    stroke: "#FF9B6B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13.2187H12.1641V14.2734C12.1641 14.8559 12.6363 15.3281 13.2188 15.3281C13.8012 15.3281 14.2734 14.8559 14.2734 14.2734V13.2187H17.4727V10.0547H16.418C15.8355 10.0547 15.3633 9.5825 15.3633 9C15.3633 8.4175 15.8355 7.94531 16.418 7.94531H17.4727V4.78125H14.2734V5.83594C14.2734 6.41844 13.8012 6.89062 13.2188 6.89062C12.6363 6.89062 12.1641 6.41844 12.1641 5.83594V4.78125H9",
    stroke: "#FF9B6B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.72656 13.2188V12.1641C3.72656 11.5816 4.19878 11.1094 4.78125 11.1094C5.36372 11.1094 5.83594 11.5816 5.83594 12.1641V13.2188H9V10.0547H10.0547C10.6372 10.0547 11.1094 9.5825 11.1094 9C11.1094 8.4175 10.6372 7.94531 10.0547 7.94531H9V4.78125H5.83594V3.72656C5.83594 3.14406 5.36375 2.67187 4.78125 2.67187C4.19875 2.67187 3.72656 3.14406 3.72656 3.72656V4.78125H0.527344V7.94531H1.58203C2.1645 7.94531 2.63672 8.4175 2.63672 9C2.63672 9.5825 2.1645 10.0547 1.58203 10.0547H0.527344V13.2188H3.72656Z",
    stroke: "#FF9B6B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchedWith);
export default __webpack_public_path__ + "static/media/matched-with.c6ef2a16c048fdb7c35336a54fa21ffe.svg";
export { ForwardRef as ReactComponent };